import SDIcon from './SDIcon'

const IconCustomEmoovz = (props) => (
  <SDIcon title='Emoovz' defaultColorKey='contentPrimary' viewBox='0 0 24 24' {...props}>
    <circle cx="8" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
    <circle cx="16" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
    <path
    d="M11 12 L13 12"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    />
  </SDIcon>
)

export default IconCustomEmoovz
